module.exports = __webpack_public_path__ + "static/media/265137_01big.99f425a2.jpg";